// TO DO: Make chip/tag into a component
import React from 'react';
import { MenuItem, Select, FormControl, Chip, Box } from '@mui/material';
import { ChevronDown16Filled, Dismiss12Filled } from '@fluentui/react-icons';

const FormMultiSelectInput = ({
  id,
  value = [],
  onChange,
  options,
  label,
  disabled,
  required,
}) => {
  //   const filteredOptions = options.filter(
  //     (opt) =>
  //       !Array.isArray(value) ||
  //       !value.some((val) => String(val.value) === String(opt.value))
  //   );

  const handleMultiSelectChange = (event) => {
    const selectedValue = event.target.value;
    const newSelection = options.find(
      (opt) => String(opt.value) === String(selectedValue)
    );

    if (
      !newSelection ||
      (Array.isArray(value) &&
        value.some((val) => String(val.value) === String(selectedValue)))
    ) {
      return;
    }

    const updatedValues = [...value, newSelection];
    onChange(updatedValues);
  };

  const handleRemoveValue = (removeValue) => {
    const updatedValues = value.filter(
      (val) => String(val.value) !== String(removeValue)
    );
    onChange(updatedValues);
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: '10px',
        border: '1px solid var(--gray-300)',
        padding: '0px',
        backgroundColor: disabled ? 'var(--gray-100)' : 'white',
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      <Select
        id={id}
        value={''}
        onChange={handleMultiSelectChange}
        displayEmpty
        IconComponent={ChevronDown16Filled}
        disabled={disabled}
        required={required}
        MenuProps={{
          PaperProps: {
            sx: { boxShadow: 2 },
          },
        }}
        sx={{
          flex: 1,
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          fontSize: '1rem',
          // height: '45px',
          // padding: '2px',

          '& .MuiSelect-icon': {
            fontSize: '1.15rem',
            color: 'var(--gray-500)',
            paddingRight: '3px',
            paddingLeft: '3px',
          },
          '& .MuiSelect-select': {
            color: value?.value ? 'var(--black)' : 'var(--gray-500)',
            padding: '12px',
          },
        }}
        renderValue={() =>
          value.length ? (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {value.map((val) => (
                <Chip
                  key={val.value}
                  label={val.label}
                  onDelete={() => handleRemoveValue(val.value)}
                  onMouseDown={(e) => e.stopPropagation()} // Prevents dropdown from opening when clicking x
                  sx={{
                    backgroundColor: 'var(--gray-100)',
                    color: 'black',
                    height: '30px',
                    fontSize: '0.9rem',
                    
                    // padding: '3px',
                    borderRadius: '5px',
                  }}
                  deleteIcon={
                    <Dismiss12Filled style={{ marginRight: '7px' }} />
                  }
                />
              ))}
            </Box>
          ) : (
            <span
              style={{ color: 'var(--gray-500)' }}
            >{`Select ${label}`}</span>
          )
        }
      >
        <MenuItem value="" disabled>{`Select ${label}`}</MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
        {/* To filter dropdown values to non-selected values */}
        {/* {filteredOptions.map((opt) => (
      <MenuItem key={opt.value} value={opt.value}>
             {opt.label}
           </MenuItem>
         ))} */}
      </Select>
    </FormControl>
  );
};

export default FormMultiSelectInput;
